<template>
  <div class="wx-open-message-tpl"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="tplList">
      <div class="tpl-wrap">
        <div class="header">
          <el-select v-model="tpl"
                     size="mini"
                     filterable
                     value-key="code"
                     placeholder="请选择模板类型">
            <el-option v-for="tpl in tplList"
                       :key="tpl.code"
                       :label="`${tpl.tid} - ${tpl.scene}`"
                       :value="tpl"></el-option>
          </el-select>
        </div>
        <div class="main">
          <div class="main-cont">
            <template v-if="tpl">
              <WxOpenMessageTplApply :key="tpl.code"
                                     :tpl="tpl"
                                     v-on="$listeners"></WxOpenMessageTplApply>
            </template>
            <template v-else>
              <Hint>
                <div>请选择模板类型</div>
              </Hint>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>模板类别加载失败</div>
        <el-button type="text"
                   @click="loadTplList">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import WxOpenMessageTplApply from './apply'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'WxOpenMessageTpl',
  components: {
    WxOpenMessageTplApply,
    Hint
  },
  data () {
    return {
      loading: false,
      tplList: null,
      tpl: null
    }
  },
  methods: {
    loadTplList () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/wx/open/tplList',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.tplList = response.data['tplList'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadTplList()
  }
}
</script>

<style lang="scss">
  .wx-open-message-tpl {
    height: 420px;
    & > .tpl-wrap {
      height: 100%;
      display: flex;
      flex-direction: column;
      & > .header {
        flex: none;
        padding: 15px;
        .el-select {
          width: 100%;
        }
      }
      & > .main {
        flex: auto;
        position: relative;
        & > .main-cont {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
</style>
